/* eslint-disable no-undef */
import { DISALLOWED_DOMAINS } from './constants';

const ClearBitIntegration = {
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  fetchPersonDetails(email, nonceValue, $form, $submitBtn, hiddenClearBitFields) {
    (function ($) {
      $.ajax({
        url: wpCustomVariables.ajaxUrl,
        type: 'POST',
        data: {
          action: 'fetch_clearbit_person_details',
          email: email,
          nonce: nonceValue,
        },
        dataType: 'json',
        success: function (responseObj) {
          $submitBtn.prop('disabled', false);
          if (responseObj && responseObj.hasOwnProperty('response')) {
            var responseBody = responseObj.response.body;
            const responseJsonObject = JSON.parse(responseBody);

            const $companyInput = $form.find('.company');
            const $lastNameInput = $form.find('.last_name');

            // Set default values to empty
            $companyInput.val('');
            $lastNameInput.val('');

            // Form shortening
            if (responseJsonObject.person && responseJsonObject.person.name && responseJsonObject.person.name.fullName) {
              var fullName = responseJsonObject.person.name.fullName;
              $lastNameInput.val(fullName);
              $lastNameInput.parent('.form-shortening').hide();
            } else {
              $lastNameInput.parent('.form-shortening').show();
            }
            if (responseJsonObject.company && responseJsonObject.company.name) {
              var companyName = responseJsonObject.company.name;
              $companyInput.val(companyName);
              $companyInput.parent('.form-shortening').hide();
            } else {
              $companyInput.parent('.form-shortening').show();
            }

            hiddenClearBitFields.forEach((field) => {
              const $field = $form.find(field.selector);
              const keys = field.key.split('.');
              let value = responseJsonObject;
              for (const key of keys) {
                if (value && value.hasOwnProperty(key)) {
                  value = value[key];
                } else {
                  value = null;
                }
              }
              if (value !== null) {
                $field.val(value);
              }
            });
          }
        },
        error: function (error) {
          // $submitBtn.prop('disabled', false);
          console.log('Error:', error);
        },
      });
    })(jQuery);
  },

  onInit() {
    (function ($) {
      const disAllowedDomains = DISALLOWED_DOMAINS;

      const hiddenClearBitFields = [
        { selector: '.00NS2000001MLRv', key: 'person.phone' },
        { selector: '.title', key: 'person.employment.title' },
        { selector: '.00NC6000000Nz0y', key: 'person.employment.role' },
        { selector: '.url', key: 'company.domain' },
        { selector: '.description', key: 'company.description' },
        // { selector: '.city', key: 'person.geo.city' },
        // { selector: '.state', key: 'person.geo.state' },
        { selector: '.00NS2000001MOSv', key: 'person.facebook.handle' },
        { selector: '.00NS2000001MH6c', key: 'person.linkedin.handle' },
        { selector: '.00NS2000001MNGl', key: 'person.twitter.handle' },
        { selector: '.00NS2000001UVDt', key: 'company.linkedin.handle' },
        { selector: '.00NS2000001UPJs', key: 'company.twitter.handle' },
        // { selector: '.industry', key: 'company.category.industry' },
        { selector: '.00N5g00000OZ5f6', key: 'company.category.subIndustry' },
        { selector: '.00NS20000014nWH', key: 'company.metrics.alexaGlobalRank' },
        // { selector: '.revenue', key: 'company.metrics.estimatedAnnualRevenue' },
        // { selector: '.00N5g00000OZ5f5', key: 'company.metrics.employees' },
      ];

      $('.email').on('input', function () {
        const $form = $(this).closest('form');
        const $submitBtn = $('.salesforce-form-submit', $form);
        const email = $(this).val().trim();
        const nonceValue = $form.find('input[name="sf_form_nonce"]').val().trim();

        const $companyInput = $form.find('.company');
        const $lastNameInput = $form.find('.last_name');

        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        const isDisallowedDomain = disAllowedDomains.some((disallowed) => email.includes(disallowed));

        if (isDisallowedDomain) {
          $companyInput.parent('.form-shortening').hide();
          $lastNameInput.parent('.form-shortening').hide();
          return;
        }

        if (email && emailPattern.test(email) && !isDisallowedDomain && nonceValue) {
          // disable button
          $submitBtn.prop('disabled', true);
          ClearBitIntegration.fetchPersonDetails(email, nonceValue, $form, $submitBtn, hiddenClearBitFields);
        } else if (email.length === 0) {
          $('.last_name', $form).val('');
          $('.company', $form).val('');
          $('.mobile', $form).val('');
          $('.00N5g00000OZ5f1', $form).val('');
        }
      });
    })(jQuery);
  },
};

export default ClearBitIntegration;
